import script from "./OrganizationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationsPage.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationsPage.vue?vue&type=style&index=0&id=4d4a2ac2&scoped=true&lang=css"
script.__scopeId = "data-v-4d4a2ac2"

export default script